import React, { useState } from "react";
import { motion } from "framer-motion";
import backbtn from "../../VideoEditor/assets/backButton.svg";
import { useHistory } from "react-router-dom";
import { SpeakerInfo } from "../BottomSidebar";
import Modal from "react-bootstrap/cjs/Modal";

type Props = {
    speakerInfo: SpeakerInfo;
    locale: string
};

const ValidationModals: React.FC<Props> = ({ speakerInfo, locale }) => {
    const [showModal, setShowModal] = useState(false);
    const history = useHistory();

    const handleBackbutton = () => {
        try {
            history.push(`/${speakerInfo.event_slug}/my-presentations/${speakerInfo.presentation_id}/videos`);
        } catch (error) {
            console.log(error);
        }
    };


    return (
        <>
            <img
                src={backbtn}
                onClick={() => setShowModal(true)}
                alt="Back Button"
                className="p-2 btn justify-content-center"
                style={{ cursor: "pointer" }}
            />

            {/* Modal */}
            {showModal && (
                <>
                    <Modal className="alert-modal" show={showModal}
                        //  onHide={handleClose}
                        size="lg">
                        {/* <Modal.Header closeButton></Modal.Header> */}
                        <Modal.Body className="Loading">
                            <div>
                                {/* <div className="Loading "> */}
                                <img src="/icons/error.svg" className="loading_image" />
                                {/* <p className=" popup_typography loading_typography_error">{message}</p>
           */}
                                <div style={{ textAlign: "center" }}>
                                    <p className="loading_typography">
                                        {`${locale == "en" ? "Changes are not saved yet. Are You Sure?" : "Les modifications ne sont pas encore enregistrées. Êtes-vous sûr?"}`}
                                    </p>
                                </div>
                                {/* <div className="error_bar"></div> */}
                                {/* </div> */}
                                {/* <p className="message_typography">{message}</p> */}

                                <button
                                    data-auto="inviteButton"
                                    className="spectrum-Button spectrum-Button--cta inviteButton-I4RMS"
                                    onClick={() => handleBackbutton()}
                                >
                                    <span>{`${locale == "en" ? "Yes" : "Oui"}`}</span>
                                </button>
                                <button
                                    onClick={() => setShowModal(false)}
                                    data-auto="inviteButton"
                                    className="spectrum-Button spectrum-Button--cta inviteButton-I4RMS"
                                >
                                    <span>{`${locale == "en" ? "No" : "Non"}`}</span>
                                </button>
                            </div>
                        </Modal.Body>
                    </Modal>

                    {/* Modal Backdrop */}
                    <div
                        className="modal-backdrop fade show"
                        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                        onClick={() => setShowModal(false)}
                    ></div>
                </>
            )}
        </>
    );
};

export default ValidationModals;
